import { LangageIso6391, RegistrationIdType } from "@tfg/db"

interface RegistrationId {
  registrationId: string
  type: RegistrationIdType
}

export namespace ContactRequests {
  export interface CreateContact {
    name: string
    email: string
    preferredLanguage: LangageIso6391
    organizationName: string
    organizationStreet: string | null
    organizationCity: string | null
    organizationPostalCode: string | null
    organizationCountry: string | null
    registrationId: RegistrationId[]
  }

  export interface TransferContact {
    email: string
    name: string
    language: LangageIso6391
    oldContactUserId: string
  }
}

export const CONTACT_WITH_INFORMATION_REQUESTS_ERROR =
  "CANNOT_DELETE_CONTACT_WITH_ASSIGNED_INFORMATION_REQUESTS" as const
